import { useState } from "react";
import { Droplets } from "lucide-react";
import { PageHeader, Loading, Plate, useFetch } from "@/components/common";
import { AdBlueDialog, AdBlueHistory } from "@/components/AdBlue";
import { Button } from "@/components/ui/button";
import { AdBlueOrders } from "@/components/AdBlueOrder";
import { useAuth } from "@/context/AuthContext";

export default function AdBluePage() {
  const { user } = useAuth();
  const canAdd = user.real_role !== "direction";
  const { data, loading, reload } = useFetch("/adblue/summary");
  const [open, setOpen] = useState(false);
  const [k, setK] = useState(0);
  return (
    <div data-testid="adblue-page">
      <PageHeader overline="Véhicules de livraison" title="Carburant / AdBlue">
        {canAdd && <Button onClick={() => setOpen(true)} className="bg-[#2F80ED] hover:bg-[#1d6fd8]" data-testid="adblue-add-btn"><Droplets className="w-4 h-4 mr-1" /> Ajouter de l'AdBlue</Button>}
      </PageHeader>
      <AdBlueOrders />
      {open && <AdBlueDialog onClose={() => setOpen(false)} onDone={() => { setOpen(false); setK((x) => x + 1); reload(); }} />}
      {loading ? <Loading /> : (data?.vehicles || []).map((v) => (
        <div key={v.id} className="bg-white border border-slate-200 rounded-xl mb-6" data-testid={`adblue-vehicle-${v.plate}`}>
          <div className="px-4 pt-4 flex items-center gap-2"><Plate>{v.plate}</Plate><span className="font-semibold text-[#0E2D43]">{v.brand} {v.model}</span></div>
          <AdBlueHistory vehicleId={v.id} k={k} />
        </div>
      ))}
    </div>
  );
}
